import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
`;

export const SpeedValueLabel = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.secondary50};
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  `,
);

export const SpeedButton = styled.button<{ $isPlayingSlowly: boolean }>(
  ({ theme, $isPlayingSlowly }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral30};
    border-radius: ${theme.bo.round};
    background-color: ${$isPlayingSlowly ? theme.co.primary20 : theme.co.neutral99};
    color: ${theme.co.secondary0};
    cursor: pointer;

    &:hover {
      border-color: ${theme.co.secondary0};
    }

    & svg {
      font-size: ${theme.sz.s6};
    }
  `,
);
